module.exports = __webpack_public_path__ + "img/files_blue.216804a7.svg";